import * as d3 from "d3";
import {inrFormatterV2} from '../functions'

export default function (chart, divId, vizName,resData, filterParam, checkbox) {
    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:", vizName)
    var bottom1 = 4

    d3.select(".tooltip" + divId.id).remove(); // clear tooltip based on class of tip element

    // json loaded asynchronously
    // axios.post(url, filterParam).then(res => {
        let data = resData
        // group the data: I want to draw one line per group
        var categories = d3.nest() // nest function allows to group the calculation per level of a factor
            .key(function (d) {
                return d.dim1_name;
            })
            .sortKeys(d3.ascending)
            .entries(data);

        // What is the list of groups?
        var allKeys = categories.map(function (d) {
            return d.key
        })

        var x = d3.scaleBand()
            .rangeRound([0, chart.width])
            .domain(data.map((d) => {
                return d.dim2_name
            }));

        //Add Y axis
        var y = d3.scaleLinear()
            .domain([(function() {
                var minVal = d3.min(data, function(d) {
                    return +d.metric1;
                });
                return (minVal < 0) ? minVal : 0;
            })(), d3.max(data, function (d) {
                return +d.metric1;
            })])
            .range([chart.height, 0]);


        function scaleBandPosition(mouse) {
            var xPos = mouse[0];
            var domain = x.domain();
            var range = x.range();
            var rangePoints = d3.range(range[0], range[1], x.step())
            console.log("pos:", domain[d3.bisectLeft(rangePoints, xPos) - 1]);

            return domain[d3.bisectLeft(rangePoints, xPos) - 1]
        }

        // color palette
        var color = d3.scaleOrdinal()
            .domain(allKeys)
            .range(['#e41a1c', '#377eb8', '#4daf4a', '#984ea3', '#ff7f00', '#ffff33', '#a65628', '#f781bf', '#999999'])

        if (checkbox == true) {
            categories.forEach(function (d) {
                d.maxNumber = d3.max(d.values, function (d) {
                    return d.metric1;
                });
            });

            var div = d3.select(divId)
            div.selectAll("*").remove();

            div = d3.select(divId).selectAll("*")
                .data(categories)
                .enter()
                .append("div")

            div.append("svg")
                .attr('width', chart.width + chart.margin.left + chart.margin.right)
                // .attr('height', chart.height + chart.margin.top + chart.margin.bottom)
                .attr("height", function (d, i) {
                    return categories[i] == categories[categories.length - 1] ?
                        chart.height + chart.margin.top + chart.margin.bottom : chart.height + chart.margin.top + bottom1
                })

                // .call(responsivefy)
                .append('g')
                .attr('transform', 'translate(' + chart.margin.left + ',' + chart.margin.top + ')')
                .attr("id", (d) => {
                    return d.key
                })

            categories.forEach(function (d) {

                //Add Y axis
                var y1 = d3.scaleLinear()
                    .domain([(function() {
                        var minVal = d3.min(d.values, function(d) {
                            return d.metric1;
                        });
                        return (minVal < 0) ? minVal : 0;
                    })(), d3.max(d.values, function (d) {
                        return +d.metric1;
                    })])
                    .range([chart.height, 0]);

                //CSS.escape(id) - will escape special character in id/key
                var div = d3.select("#" + CSS.escape(d.key));
                y.domain([0, d.maxNumber]);

                div.append('g')
                    .attr('transform', 'translate(0,' + chart.height + ')')
                    .call(d3.axisBottom(x))
                    .selectAll('text')
                    .style('text-anchor', 'end')
                    .attr('dx', '-.8em')
                    .attr('dy', '-.20em')
                    .attr('transform', 'rotate(-60)')

                div.append("g").call(d3.axisLeft(y).tickFormat(function (d){
                    return inrFormatterV2(d, chart.data.menuId)
                }).ticks(10));

                div.append('path')
                    .attr('fill', 'none')
                    .attr('stroke', function (d) {
                        return color(d.key)
                    })
                    .attr('stroke-width', 1.5)
                    .attr('d', (d) => {
                        let line = d3.line()
                            .x(d => {
                                return x(d.dim2_name)
                            })
                            .y(d => {
                                return y(+d.metric1)
                            })
                        return line(d.values)
                    })
                    .on("mouseover", function () {
                        focus.style("display", null);
                    })
                    .on("mouseout", function () {
                        focus.style("display", "none");
                    })
                    .on("mousemove", function (d) {
                        var mouse = d3.mouse(this);
                        var xDate = scaleBandPosition(mouse)
                        var bisect = d3.bisector(function (d) {
                            return d.dim2_name
                        }).left
                        var idx = bisect(d.values, xDate)
                        console.log("tooltip:", d.values[idx].metric1);
                        focus.attr("transform", "translate(" + x(d.values[idx].dim2_name) + "," + y1(d.values[idx].metric1) + ")");
                        focus.select(".tooltip-date").text((d.values[idx].dim2_name));
                        focus.select(".tooltip-likes").text(inrFormatterV2(d.values[idx].metric1,chart.data.menuId));
                    });
                // .on('mouseover', y1tip.show)
                //.on('mouseout', y1tip.hide)
                // .call(y1tip);
                var focus = div.append("g")
                    .attr("class", "focus")
                    .style("display", "none");

                focus.append("circle")
                    .attr("r", 5)
                    .attr('fill', function (d) {
                        console.log("color", color(d.key));
                        return color(d.key)
                    })
                    //.attr('fill','red')
                    .attr('stroke', function (d) {
                        return color(d.key)
                    });

                focus.append("rect")
                    .attr("class", "tooltip")
                    .attr("width", 100)
                    .attr("height", 50)
                    .attr("x", 10)
                    .attr("y", -22)
                    .attr("rx", 4)
                    .attr("ry", 4);

                focus.append("text")
                    .attr("class", "tooltip-date")
                    .attr("x", 18)
                    .attr("y", -2);

                focus.append("text")
                    .attr("x", 18)
                    .attr("y", 18)
                    .text("Value:");

                focus.append("text")
                    .attr("class", "tooltip-likes")
                    .attr("x", 60)
                    .attr("y", 18);

                //adding category name at right hand side
                div.append("text")
                    .attr("x", chart.width - 100)
                    .attr("y", chart.height / 3)
                    .attr("dy", ".71em")
                    .attr("text-anchor", "start")
                    .attr("font-size", "0.8em")
                    .text(function (d) {
                        return (d.key)
                    })
                    .style("fill", function (d) {
                        return color(d.key)
                    });
            });
        } else {
            //x.domain(data.map((d) =>{ return d.dim2_name; }));
            //  y.domain([0, d3.max(data.map((d) =>{ return d.metric1 }))]);
            d3.select(".tooltip" + divId.id).remove(); // clear tooltip based on class of tip element

            var svg = d3.select(divId)
            svg.selectAll("*").remove();

            svg = d3.select(divId).selectAll("svg")
                .data(categories)
                .enter()
                .append("svg")
                .attr('width', chart.width + chart.margin.left + chart.margin.right)
                // .attr('height', chart.height + chart.margin.top + chart.margin.bottom)
                .attr("height", function (d, i) {
                    return categories[i] == categories[categories.length - 1] ?
                        chart.height + chart.margin.top + chart.margin.bottom : chart.height + chart.margin.top + bottom1
                })
                //.call(responsivefy)
                .append('g')
                .attr('transform', 'translate(' + chart.margin.left + ',' + chart.margin.top + ')')
                .attr("id", (d) => {
                    return d.key
                })

            svg.append('g')
                .attr('transform', 'translate(0,' + chart.height + ')')
                .call(d3.axisBottom(x))
                .selectAll('text')
                .style('text-anchor', 'end')
                .attr('dx', '-.8em')
                .attr('dy', '-.20em')
                .attr('transform', 'rotate(-60)')

            svg.append("g").call(d3.axisLeft(y).tickFormat(function (d){
                return inrFormatterV2(d,chart.data.menuId)
            }).ticks(10));

            svg.append('path')
                .attr('fill', 'none')
                .attr('stroke', function (d) {
                    return color(d.key)
                })
                .attr('stroke-width', 1.5)
                .attr('d', (d) => {
                    let line = d3.line()
                        .x(d => {
                            console.log("test1:", d.dim2_name);
                            return x(d.dim2_name)
                        })
                        .y(d => {
                            return y(+d.metric1)
                        })
                    return line(d.values)
                })
                /* .on('mouseover', y1tip.show)
                .on('mouseout', y1tip.hide)
                .call(y1tip);*/
                .on("mouseover", function () {
                    focus.style("display", null);
                })
                .on("mouseout", function () {
                    focus.style("display", "none");
                })
                .on("mousemove", function (d) {
                    var mouse = d3.mouse(this);
                    var xDate = scaleBandPosition(mouse)
                    var bisect = d3.bisector(function (d) {
                        return d.dim2_name
                    }).left
                    var idx = bisect(d.values, xDate)
                    console.log("tooltip:", d.values[idx].metric1);
                    console.log("tooltipX:", d.values[idx]);
                    console.log("tooltipY:", y(d.values[idx].metric1));
                    focus.attr("transform", "translate(" + x(d.values[idx].dim2_name) + "," + y(d.values[idx].metric1) + ")");
                    focus.select(".tooltip-date").text((d.values[idx].dim2_name));
                    focus.select(".tooltip-likes").text(inrFormatterV2(d.values[idx].metric1,chart.data.menuId));
                });

            var focus = svg.append("g")
                .attr("class", "focus")
                .style("display", "none");

            focus.append("circle")
                .attr("r", 5)
                .attr('fill', function (d) {
                    console.log("color", color(d.key));
                    return color(d.key)
                })
                .attr('stroke', function (d) {
                    return color(d.key)
                });

            focus.append("rect")
                .attr("class", "tooltip")
                .attr("width", 100)
                .attr("height", 50)
                .attr("x", 10)
                .attr("y", -22)
                .attr("rx", 4)
                .attr("ry", 4);

            focus.append("text")
                .attr("class", "tooltip-date")
                .attr("x", 18)
                .attr("y", -2);

            focus.append("text")
                .attr("x", 18)
                .attr("y", 18)
                .text("Value:");

            focus.append("text")
                .attr("class", "tooltip-likes")
                .attr("x", 60)
                .attr("y", 18);

            /*function mousemove1() {
                             var mouse = d3.mouse(this);
                             var xDate = scaleBandPosition(mouse)
                             var bisect = d3.bisector(function (d) { return d.dim2_name }).left
                             var idx = bisect(d.values, xDate)
                             console.log("tooltip:",d.values[idx]);
                             focus.attr("transform", "translate(" + x(d.values[idx].dim2_name)   + "," + y(d.values[idx].metric1) + ")");
                             focus.select(".tooltip-date").text((d.values[idx].dim2_name));
                             focus.select(".tooltip-likes").text(numberFormat(d.values[idx].metric1));
            }*/

            // Add titles
            /*svg.append("text")
                .attr("text-anchor", "start")
                .attr("y", -5)
                .attr("x", 0)
                .text(function(d){ console.log("right side",d.key); return(d.key)})
                .style("fill", function(d){ return color(d.key) });*/

            //adding category name at right hand side
            svg.append("text")
                .attr("x", chart.width - 100)
                .attr("y", chart.height / 3)
                .attr("dy", ".71em")
                .attr("text-anchor", "start")
                .attr("font-size", "0.8em")
                .text(function (d) {
                    console.log("right side", d.key);
                    return (d.key)
                })
                .style("fill", function (d) {
                    return color(d.key)
                });
        }

    // });
}
